import React from 'react';
import { RemoteFeatureFlagKeys, useIsFeatureEnabled } from '@shared/core/featureFlags';

type DiscountExperiments = Extract<RemoteFeatureFlagKeys, 'travelHotelCouponsAccommodationItem'>;

export const DiscountExperimentEnabled = ({ control, treatment, expKey }: Readonly<{ control: React.ReactNode; expKey: DiscountExperiments; treatment: React.ReactNode }>) => {
  const enabled = useIsFeatureEnabled(expKey);
  return enabled ? <>{treatment}</> : <>{control}</>;
};
